(function () {
  const SELECTOR_OPEN = '[data-open-modal]';
  const SELECTOR_CLOSE = '[data-close-modal]';

  const getModal = (id) => document.getElementById(id);

  // ---- scroll lock with gutter compensation (multi-modal safe) ----
  let lockCount = 0;

  const htmlEl = document.documentElement;
  const bodyEl = document.body;
  const scrollEl = document.scrollingElement || htmlEl; // actual scroller

  const state = {
    sbw: 0,
    prev: {
      scrollOverflow: '',
      scrollPadRight: '',
      htmlOverflow: '',
      bodyOverflow: '',
      backToTopRight: '',
      footerPads: [] // [{el, prev}]
    },
  };

  function getScrollbarWidth() {
    const w = window.innerWidth - document.documentElement.clientWidth;
    return w > 0 ? w : 0;
  }

  function lockScroll() {
    if (lockCount === 0) {
      state.sbw = getScrollbarWidth();

      // remember exact inline styles to restore later
      state.prev.scrollOverflow = scrollEl.style.overflow || '';
      state.prev.scrollPadRight = scrollEl.style.paddingRight || '';
      state.prev.htmlOverflow = htmlEl.style.overflow || '';
      state.prev.bodyOverflow = bodyEl.style.overflow || '';

      // add gutter to the real scroller padding to avoid layout shift
      if (state.sbw > 0) {
        const currentPad = parseFloat(getComputedStyle(scrollEl).paddingRight || '0') || 0;
        scrollEl.style.paddingRight = (currentPad + state.sbw) + 'px';

        // #atd-back-to-top: bump "right" by sbw
        const btt = document.getElementById('atd-back-to-top');
        if (btt) {
          state.prev.backToTopRight = btt.style.right || '';
          const currRight = parseFloat(getComputedStyle(btt).right || '0') || 0;
          btt.style.right = (currRight + state.sbw) + 'px';
        }

        // .atd-product-sticky-footer__container: bump padding-right by sbw
        state.prev.footerPads = [];
        document.querySelectorAll('.atd-product-sticky-footer__container').forEach((el) => {
          state.prev.footerPads.push({ el, prev: el.style.paddingRight || '' });
          const curr = parseFloat(getComputedStyle(el).paddingRight || '0') || 0;
          el.style.paddingRight = (curr + state.sbw) + 'px';
        });
      }

      // lock scroll on both html/body (cross-theme safety)
      scrollEl.style.overflow = 'hidden';
      htmlEl.style.overflow = 'hidden';
      bodyEl.style.overflow = 'hidden';

      htmlEl.classList.add('atd-modal--open');
    }
    lockCount++;
  }

  function unlockScrollIfNoneOpen() {
    const anyOpen = document.querySelector('.atd-modal[aria-hidden="false"]');
    if (anyOpen) return; // another modal is still open

    lockCount = 0;

    // restore exactly what we saved
    scrollEl.style.overflow = state.prev.scrollOverflow || '';
    scrollEl.style.paddingRight = 0;

    htmlEl.style.overflow = 'unset';
    bodyEl.style.overflow = 'unset';

    // restore #atd-back-to-top right
    const btt = document.getElementById('atd-back-to-top');
    if (btt) btt.style.right = state.prev.backToTopRight || '';

    // restore footer containers padding-right
    if (state.prev.footerPads && state.prev.footerPads.length) {
      state.prev.footerPads.forEach(({ el, prev }) => {
        if (el) el.style.paddingRight = prev || '';
      });
      state.prev.footerPads = [];
    }

    htmlEl.classList.remove('atd-modal--open');
  }

  function openModal(id) {
    const modal = getModal(id);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    const panel = modal.querySelector('.atd-modal__panel');
    if (panel) panel.focus();
    // lockScroll();
  }

  function closeModal(el) {
    const modal = el.closest('.atd-modal') || el;
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    unlockScrollIfNoneOpen();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest(SELECTOR_OPEN);
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-open-modal'));
      return;
    }
    const closer = e.target.closest(SELECTOR_CLOSE);
    if (closer) {
      e.preventDefault();
      closeModal(closer);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.atd-modal[aria-hidden="false"]').forEach((m) => {
        m.setAttribute('aria-hidden', 'true');
      });
      unlockScrollIfNoneOpen();
    }
  });
})();
